var swiperMenu

function MyAccountMenuSlider() {
  swiperMenu = new Swiper(".js-my-account-menu-slider", {
    slidesPerView: "auto",
    breakpoints: {
      // when window width is >= 576px
      576: {
        allowTouchMove: false
      }
    }
  });
}

function MyAccountTabs() {
  $('.js-tabs-button').on('click', function () {
    let $this = $(this);
    let $parent = $this.closest('.js-tabs');
    let needBlock = $this.attr('data-target');
    let slideIndex = $(this).closest('.swiper-slide').index();

    $parent.find('.js-tabs-button').removeClass('is-active');
    $parent.find('.js-tabs-block').hide();
    $this.addClass('is-active');

    swiperMenu.slideTo(slideIndex, 1000, false);

    $parent.find('.js-tabs-block[data-block="' + needBlock + '"]').fadeIn();
    $parent.find('.js-tabs-button[data-target="' + needBlock + '"]').addClass('is-active');
  });
}

function AnchorLinkTab() {
  let params = (new URL(document.location)).searchParams;
  let openTab = params.get('open-tab');

  if (openTab != null) {
    let slideIndex = $('.js-tabs-button[data-target="' + openTab + '"]').closest('.swiper-slide').index();
    $('.js-tabs-button').removeClass('is-active');
    $('.js-tabs-block').hide();

    swiperMenu.slideTo(slideIndex, 1000, false);

    $('.js-tabs-block[data-block="' + openTab + '"]').fadeIn();
    $('.js-tabs-button[data-target="' + openTab + '"]').addClass('is-active');
  }
}

export { MyAccountMenuSlider, MyAccountTabs, AnchorLinkTab };